import React from "react";
import { formatNumbers } from "../../utils/formatNumbers";

const GrandTotalValue = ({
  grandTotal = 0,
  discount = 0,
  currency = "",
  isFoc = null,
  as = "p",
}) => {
  if (isFoc === true) {
    const Tag = as;
    return <Tag className="checkout__grand-total-current">Free</Tag>;
  }

  const originalTotal = discount > 0 ? grandTotal + discount : null;
  const Tag = as;

  return (
    <div className="checkout__grand-total-prices">
      <Tag className="checkout__grand-total-current">
        {formatNumbers(grandTotal, true)} {currency}
      </Tag>
      {originalTotal != null && (
        <span className="checkout__grand-total-original">
          {formatNumbers(originalTotal, true)} {currency}
        </span>
      )}
    </div>
  );
};

export default GrandTotalValue;
